import type { ReactNode } from 'react';
import { QueryProvider } from './providers/QueryProvider';
import { HelmetProvider } from 'react-helmet-async';
import { I18nProvider } from './providers/I18nProvider';
import { ToastStack } from '../shared/notifications/ToastStack';
import { useReferralAttribution } from '../features/referrals/hooks/useReferralAttribution';

interface AppProvidersProps {
  children: ReactNode;
}

function ReferralAttributionBootstrap() {
  useReferralAttribution();
  return null;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <I18nProvider>
        <HelmetProvider>
          {children}
          <ToastStack />
          <ReferralAttributionBootstrap />
        </HelmetProvider>
      </I18nProvider>
    </QueryProvider>
  );
}
